import { LOCALE_INTERNAL_LINKS_PATHS } from 'types/locales';

const keywordsUS = [
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.SOLD_PRICES,
    link: '/sold',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.HOUSES_FOR_SALE,
    link: '/houses',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.CONDOS_FOR_SALE,
    link: '/condos',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.TOWNHOUSES_FOR_SALE,
    link: '/townhouses',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.HOME_APPRAISAL,
    link: '/home-appraisal',
    type: 'other',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.FIND_AN_AGENT,
    link: '/agents-search',
    type: 'other',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.HOUSES,
    link: '/search?townhouse=false&condo=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS['3_BED_HOUSES'],
    link: '/search?bedrooms=3&condo=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS['2_BED_CONDOS'],
    link: '/search?bedrooms=2&house=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS['1_BED_CONDOS'],
    link: '/search?bedrooms=1&house=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.CONDOS_FOR_RENT,
    link: '/filter?rental=true&townhouse=false&house=false&commercial=false&farm=false&land=false',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.HOUSES_FOR_RENT,
    link: '/filter?rental=true&townhouse=false&condo=false&commercial=false&farm=false&land=false',
    type: 'area',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.CONDOS_UNDER_500K,
    link: '/search?price-max=500000&house=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.HOUSES_UNDER_1_MIL,
    link: '/search?price-max=1000000&condo=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.CONDOS_OVER_1_MILLION,
    link: '/search?price-min=1000000&house=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
  {
    label: LOCALE_INTERNAL_LINKS_PATHS.MOST_EXPENSIVE_HOUSES,
    link: '/search?sort=-price&condo=false&townhouse=false&land=false&commercial=false&farm=false',
    type: 'search',
  },
];

export default keywordsUS;